export default {
    STANDARD_TYPE: 1,
    NEGOTIATED_TYPE: 2,
    CHARITY_TYPE: 3,
};



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-flights-view/flight-recommendation/flight-fare/fare-types.js